<div class="py-5 mt-10 px-4 sm:px-6 md:px-8">
  <div class="max-w-7xl mx-auto">
    <div class="grid grid-cols-1">
      <div>
        <h2 class="text-heading-black text-center md:text-left" [className]="language === 'ar' && 'text-right'">
          {{ 'CERTIFICATIONS.LABELS.CERTIFICATION_STATEMENT' | transloco }}
        </h2>
      </div>
    </div>
  </div>
</div>

<!-- logo container, visible only for mobile devices -->
<div class="py-4 flex justify-center md:hidden">
      <app-logo [width]="140" [height]="44.68"></app-logo>
</div>

<div class="py-10 px-4 sm:px-6 md:px-8">
  <div class="max-w-7xl mx-auto">
    <div class="grid grid-cols-1 gap-6">
      @if (language === 'en') {
      <section class="certifications mb-6">
        <p class="text-gray-700">
          <span class="font-bold">I/We declare</span> that all particulars and information provided herein are true, correct, complete and up-to-date in every respect
          and that no information has been withheld. <span class="font-bold">I/We acknowledge</span> that <span class="font-bold">HALA Payments</span> will rely on the information in this form unless
          and until I/We deliver written notice—by submitting an updated Self-Certification & Declaration Form—within thirty (30) calendar
          days of any change in circumstances.
        </p>
        <p class="text-gray-700">          
          <span class="font-bold">I/We undertake</span> to notify HALA Payments of any such changes and to supply updated documents promptly when they occur.
        </p>
        <p class="text-gray-700">
          <span class="font-bold">I/We further undertake</span> to inform HALA Payments if I/We am/are away from my/our country of residence for any period that
          may affect the United States Substantial Presence Test, or any comparable presence test in the countries where I/We am/are tax
          resident.
        </p>
        <p class="text-gray-700">
          <span class="font-bold">I/We accept</span> that all payments made to me/us will be <span class="font-bold">net of any withholding taxes, governmental dues or other impositions
          </span>required by domestic or foreign regulators or tax authorities, and that HALA Payments bears no liability in this regard.
        </p>
        <p class="text-gray-700">
          <span class="font-bold">I/We hereby waive</span> the duty of confidentiality and <span class="font-bold">authorize HALA Payments</span> to disclose, when required by law or competent
          authority, any account-related information to courts, regulators, tax authorities or other governmental bodies in the Kingdom of
          Saudi Arabia or any other jurisdiction, without further notice to me/us.
        </p>
      </section>
      }

      @if (language === 'ar') {
      <div class="col">
        <section class="certifications ar mb-6">
          <p class="text-gray-700">
           <span class="font-bold"> أُقِرّ/نُقِرّ</span> بأن جميع البيانات والمعلومات الواردة في هذا النموذج صحيحة ودقيقة وكاملة ومُحدَّثة من جميع النواحي، ولم أقم/نقم بحجب أي
            معلومات.<span class="font-bold"> وأُقِرّ/نُقِرّ</span> بأن<span class="font-bold"> شركة هلا للمدفوعات</span> ستعتمد على هذه المعلومات ما لم أقدّم/نقدّم إشعـاراً كتابياً مُرضيًا لشركة هلا للمدفوعات متضمناً
            نموذج الإقرار الذاتي المحدَّث خلال ثلاثين (30) يومًا تقويميًا من أي تغيير يطرأ على الظروف
          </p>
          <p class="text-gray-700">
           <span class="font-bold"> وأتعهد/نتعهد</span> بإبلاغ شركة هلا للمدفوعات بأي تغيير في المعلومات/الظروف المذكورة، وتزويدها بالمستندات المحدثة فور حدوث ذلك
          </p>
          <p class="text-gray-700">
           <span class="font-bold"> وأتعهد/نتعهد</span> بإبلاغ شركة هلا للمدفوعات إذا كنت/كنا خارج دولة الإقامة لأي مدة قد تؤثر في اختبار الوجود الفعلي في الولايات المتحدة أو أي اختبار مماثل في الدول التي أُعَدّ/نُعَدّ فيها مقيمًا ضريبيًا.
            
          </p>
          <p class="text-gray-700">
           <span class="font-bold"> وأُقِرّ/نُقِرّ وأقبل/نقبل</span> بأن جميع المدفوعات المستحقة لي/لنا ستكون صافية بعد خصم أي ضرائب اقتطاعية أو رسوم حكومية أو التزامات أخرى يفرضها المنظمون أو الجهات الضريبية المحلية أو الأجنبية، ولا تتحمل شركة هلا للمدفوعات أي مسؤولية في هذا الشأن.
          </p>
          <p class="text-gray-700">            
          <span class="font-bold"> وأتنازل/نتنازل</span> عن سرية الحساب،<span class="font-bold"> وأُفوّض/نفوض</span> شركة هلا للمدفوعات بالإفصاح، متى طُلب ذلك بموجب القانون أو من جهة مختصة، عن أي معلومات تتعلق بحسابي/حسابنا إلى المحاكم أو الجهات التنظيمية أو الضريبية أو أي جهة حكومية أخرى داخل المملكة العربية السعودية أو خارجها، دون حاجة إلى إشعار آخر مني/منا.
          </p>
        </section>
      </div>
      }
    </div>
  </div>
</div>